import {NgModule} from '@angular/core';
import { LudyUIReact } from './LudyUIReact';

@NgModule({
  declarations: [LudyUIReact],
  imports: [],
  entryComponents:[],
  exports: [LudyUIReact]
})
export class LudyUiReactModule {

  
}